module.exports = __webpack_public_path__ + "static/media/PH3800__005_Intense.d377631d.mp3";